import L from 'leaflet'

/**
 * Remove the trailing slash from an URL and return it
 */
export function removeTrailingSlash(url: string): string {
  return url.replace(/\/*$/, '')
}

/**
 * Increase the dimension of the bounds
 */
export function buildLargerBounds(
  bounds: L.LatLngBounds,
  increaseBounds: boolean = true
): L.LatLngBounds {
  const ne = bounds.getNorthEast()

  const sw = bounds.getSouthWest()

  const width = Math.abs(ne.lng - sw.lng)
  const height = Math.abs(ne.lat - sw.lat)
  const biggestDimension = width > height ? width : height
  const halfBiggestDimentions = increaseBounds ? biggestDimension / 2 : 0

  return L.latLngBounds(
    L.latLng(
      sw.lat - halfBiggestDimentions,
      sw.lng - halfBiggestDimentions
    ).wrap(),
    L.latLng(
      ne.lat + halfBiggestDimentions,
      ne.lng + halfBiggestDimentions
    ).wrap()
  )
}
